import React from 'react';

import Translation from '../../../../services/translation.service';
import { translationPrefix } from '../data'; 

export const PromptMessage = () => {
  return <div className="prompt">{Translation.keys[translationPrefix + "take_survey_prompt"]}</div> 
}
